export const Functions = {
  create: false,
  delete: false,
  detail: false,
  search: false,
};

export const PageName = '团队签到记录';
